import { FC, ReactNode } from 'react';
import FormGroup, { FormGroupProps } from 'components/FormGroup';
import CountrySelect, { BaseCountrySelectProps } from 'components/forms/CountrySelect';
import { CountryTypeEnum } from 'types/common';
import type { CustomerInfoKeyType } from 'types/customer';

export const defaultFieldsOfDeliveryCountry: CustomerInfoKeyType[] = ['delivery_country'];

export interface DeliveryCountryFormutil {
    delivery_country: string;
}

interface DeliveryCountryProps extends FormGroupProps {
    countrySelectProps?: BaseCountrySelectProps;
    disabled?: boolean;
    label?: ReactNode;
}

/**
 * @description 邮寄国家，现在非SSN开户时允许自由选择，切换时会根据邮寄国家计算对应的邮寄地址类型。
 */
const DeliveryCountry: FC<DeliveryCountryProps> = ({
    label = __('Country/Region of Mailing Address'),
    disabled,
    countrySelectProps,
    ...restProps
}) => {
    return (
        <FormGroup
            label={label}
            name="delivery_country"
            checker={value => {
                if (disabled) {
                    return true;
                }

                if (!value) {
                    return __('请选择国家或者地区');
                }

                return true;
            }}
            {...restProps}>
            <CountrySelect
                fieldName="delivery_country"
                type={CountryTypeEnum.NON_SSN_MAILING}
                isSSN={false}
                disabled={disabled}
                {...countrySelectProps}
            />
        </FormGroup>
    );
};

export default DeliveryCountry;
